/*
  Halloween vibes
  Tags the Halloween menu item and the Halloween "view all" button so
  halloween-vibes.css can style them. Nothing here is required for the page to
  work: if this file does not run, the CSS fallback selectors still colour the
  plain <a href="/collections/halloween"> links.

  The collection handle is read from window.hwCollectionHandle (set in
  layout/theme.liquid) so there is one place to change it.
*/
(function () {
  var handle = (window.hwCollectionHandle || 'halloween').toLowerCase();

  // Where a theme keeps its navigation. Add to this list if a theme wraps its
  // menu in something else.
  var NAV_ROOTS = [
    'header',
    '.header',
    '.site-header',
    'nav',
    '.site-nav',
    '.menu-drawer',
    '.mobile-nav',
    '[role="navigation"]',
  ];

  // True for /collections/halloween, /pages/halloween and their localised
  // variants (/de/collections/halloween), but not for /collections/x-halloween.
  function isHalloweenLink(a, collectionOnly) {
    var path;

    // "#", an empty href, or a non-page scheme all resolve to the current
    // page, which would match every menu item while the visitor is on the
    // Halloween collection. A dropdown parent such as "Help" is usually
    // exactly this, so skip these before looking at the path at all.
    // Pagination links on the Halloween collection also end in /halloween (?page=2),
    // they are navigation, not a menu item: never style them.
    if (a.closest('.pagination, .pagination--debut, .pagination-wrapper, nav[aria-label*="Pagin"], nav[aria-label*="pagin"]')) return false;
    var raw = (a.getAttribute('href') || '').trim();
    if (raw === '' || raw.charAt(0) === '#') return false;
    if (/^(javascript|mailto|tel|sms):/i.test(raw)) return false;

    try {
      path = new URL(a.href, window.location.origin).pathname;
    } catch (e) {
      return false;
    }
    path = path.replace(/\/+$/, '').toLowerCase();
    if (collectionOnly && path.indexOf('/collections/') === -1) return false;
    return path.split('/').pop() === handle;
  }

  // Decorative icons are injected rather than drawn with ::after, so each one
  // can animate on its own and sit tight against the label. aria-hidden keeps
  // them out of the accessible name of the link.
  function addIcons(el, html, className) {
    if (el.querySelector('.' + className)) return;
    var box = document.createElement('span');
    box.className = className;
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML = html;

    // Menu items with a submenu end in an arrow or caret icon, so slot the
    // decoration in before that instead of after it.
    var icon = el.querySelector('.svg-wrapper, svg');
    if (icon) {
      el.insertBefore(box, icon);
    } else {
      el.appendChild(box);
    }
  }

  function decorateNav(el) {
    addIcons(el, '<i class="hw-i hw-i--pumpkin"></i>', 'hw-nav-icons');
    el.classList.add('hw-nav--js');
  }

  function decorateButton(el) {
    addIcons(el, '<i></i><i></i><i></i>', 'hw-bats');
    el.classList.add('hw-button--js');
  }

  function tagMenu(root) {
    var scope = root || document;

    // Top level items that open a submenu carry the handle in their id.
    scope
      .querySelectorAll('#HeaderMenu-' + handle + ', #HeaderDrawer-' + handle)
      .forEach(function (el) {
        el.classList.add('hw-nav');
        el.classList.add('hw-nav--bat');
        decorateNav(el);
      });

    // Dawn calls these .header and .menu-drawer; other themes use .site-header,
    // .site-nav, <nav> and so on, so cast a wider net. The descendant part has
    // to be appended to every root, not to the comma separated list as a whole.
    var navLinks = NAV_ROOTS.map(function (root) {
      return root + ' a[href]';
    }).join(', ');

    scope.querySelectorAll(navLinks).forEach(function (a) {
      if (!isHalloweenLink(a)) return;
      a.classList.add('hw-nav');

      // Skip the icons when a parent (a summary, say) already carries them.
      if (a.parentElement && a.parentElement.closest('.hw-nav--bat')) return;

      a.classList.add('hw-nav--bat');
      decorateNav(a);
    });
  }

  function tagButtons(root) {
    var scope = root || document;

    // Dawn's "view all" sits in .collection__view-all. Elsewhere, treat any
    // link to the collection that is styled as a button as the same thing,
    // as long as it is not part of the navigation.
    var BUTTONS =
      '.collection__view-all a[href], a.button[href], a.btn[href], a[class*="button"][href]';

    scope.querySelectorAll(BUTTONS).forEach(function (a) {
      if (!isHalloweenLink(a, true)) return;
      if (a.closest(NAV_ROOTS.join(', '))) return;
      a.classList.add('hw-button');
      decorateButton(a);
    });
  }

  // The collection page heading, so the orange glow does not depend on Dawn's
  // class name. First heading inside the main content wins.
  function tagTitle(root) {
    if (!document.body.classList.contains('hw-page')) return;
    var scope = root || document;
    var title = scope.querySelector(
      '.collection-hero__title, main h1, #MainContent h1, .main-content h1'
    );
    if (title) title.classList.add('hw-title');
  }

  function run(root) {
    tagMenu(root);
    tagButtons(root);
    tagTitle(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  // Re-run when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
